import { render, staticRenderFns } from "./WmCategoryProperty.vue?vue&type=template&id=44ed7d1e&scoped=true&"
import script from "./WmCategoryProperty.vue?vue&type=script&lang=js&"
export * from "./WmCategoryProperty.vue?vue&type=script&lang=js&"
import style0 from "./WmCategoryProperty.vue?vue&type=style&index=0&id=44ed7d1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ed7d1e",
  null
  
)

export default component.exports